import { Box, Heading, Text } from 'braid-design-system';

import * as styles from './Shimmer.css';

interface Props {
  width: 'small' | 'medium' | 'large';
}

type HeadingProps = Props &
  Omit<React.ComponentProps<typeof Heading>, 'children'>;
type TextProps = Props & Omit<React.ComponentProps<typeof Text>, 'children'>;

export const Shimmer = {
  Heading: ({ width, ...restProps }: HeadingProps) => (
    <Box className={styles.containerVariants[width]}>
      <Heading {...restProps}>
        &nbsp;
        <Box className={styles.shimmer} />
      </Heading>
    </Box>
  ),
  Text: ({ width, ...restProps }: TextProps) => (
    <Box className={styles.containerVariants[width]}>
      <Text {...restProps}>
        &nbsp;
        <Box className={styles.shimmer} />
      </Text>
    </Box>
  ),
};
